import React from 'react';
import { Link } from 'react-router-dom';

interface ToolProps {
  icon: string;
  name: string;
  url: string;
  track: string;
}

const Tool: React.FC<ToolProps> = ({ icon, name, url, track }) => {
  return (
    <Link
      to={{ pathname: url }}
      className="tool"
      target="_blank"
      rel="noreferrer"
      title={name}
      data-track={track}
      data-url={url}
    >
      <img src={icon} alt={name} />
      <span className="text-bold name">{name}</span>
      <span>
        详情
        <span className="icon icon-arrow-right" />
      </span>
    </Link>
  );
};

export default Tool;
